<template>
  <nav v-if="showBreadcrumb && $route.path !== '/' && showLayout" class="order-first mb-2 block text-left text-16px max-md:text-12px">
    <div class="product-router-nav">
      <div class="product-router-nav-warp">
        <nuxt-link href="/">
          {{ $t('breadcrumb.home') }}
        </nuxt-link>
        <template v-for="(item, index) in breadcrumbList" :key="item.path">
          <span>/</span>
          <nuxt-link data-allow-mismatch :to="index !== (breadcrumbList?.length - 1) ? item?.path : ''">
            {{ item.name }}
          </nuxt-link>
        </template>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
const breadcrumbStore = useBreadcrumbStore()
const { breadcrumbList, showBreadcrumb, breadcrumb } = storeToRefs(breadcrumbStore)
const { showLayout } = useUseLayout()
// 监听路由变化，更新面包屑
const route = useRoute()
const app = useNuxtApp()
// 排除的路径
const exclude = [
  'products',
  'collections',
  'blog',
]
// 提取更新面包屑的逻辑为函数
function updateBreadcrumb(toPath: any) {
  // 如果不是数组或者数组为空，直接返回，不修改面包屑
  if (!Array.isArray(toPath) || toPath.length === 0)
    return

  // 如果包含排除的路径，直接返回，不修改面包屑
  if (exclude.some(path => toPath.includes(path)))
    return

  // 获取最后一个路径段
  const lastSegment = toPath[toPath.length - 1]

  // 只有当 lastSegment 有值且不是 'undefined' 字符串时才设置面包屑
  if (lastSegment && lastSegment !== 'undefined') {
    breadcrumb.value = [
      {
        name: lastSegment,
        path: `/${toPath.join('/')}`,
      },
    ]
  }
}

// 使用 effectScope 来管理副作用
const scope = effectScope()

await callOnce(async () => {
  try {
    const promises = Object.values(toValue(app._asyncDataPromises) || {})

    await Promise.allSettled(promises)

    updateBreadcrumb(route.params.all)
  }
  catch (error) {
    console.error('Server Pinia prefetch error:', error)
  }
})

// 在 effectScope 中设置路由监听器
scope.run(() => {
  // 监听路由参数变化
  watch(
    () => route.params.all,
    (newParams) => {
      updateBreadcrumb(newParams)
    },
    { immediate: true },
  )
})

// 组件卸载时清理副作用
onBeforeUnmount(() => {
  scope.stop()
})
</script>

<style lang="scss" scoped>
a:empty {
  display: none;
}

.product-router-nav {
  font-size: 14px;
  line-height: 22px;
  flex-wrap: wrap;
  padding: 16px;
  background: var(--bg-color);
}
.product-router-nav-warp {
  margin: 0 auto;
  max-width: calc(var(--page_width) * 1px);
}
.product-router-nav a {
  font-size: 14px;
  line-height: 17px;
}
.product-router-nav span {
  padding: 0 4px;
}
</style>
